import { render, staticRenderFns } from "./ResultsServiceUser.vue?vue&type=template&id=53b04b9e&"
import script from "./ResultsServiceUser.vue?vue&type=script&lang=js&"
export * from "./ResultsServiceUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports